import React from 'react'
import { clsx } from 'clsx'
import { Tooltip, TooltipTrigger } from 'chemistry'

export const AttributeRow = ({ index, displayName, description, value, flexBasis50 = true }) => (
  <div
    key={`dt-${displayName}`}
    className={clsx('mxd-attr flex justify-between gap-1', index % 2 === 0 && 'mxd-attr-prominent')}
  >
    <dt className={clsx('flex gap-half', flexBasis50 && 'mxd-flex-basis-50')}>
      {displayName}
      {description && (
        <Tooltip content={description}>
          <TooltipTrigger display='inline-block' fontSize='11px' lineHeight='15px' ml={0} mt={0} mb={0} />
        </Tooltip>
      )}
    </dt>
    <dd className={clsx('m0 bold flex right-align justify-end')}>{value}</dd>
  </div>
)
